import React, { useState, useEffect } from 'react';
import { useMutation } from '@apollo/react-hooks';
import {
  Button,
  Container,
  Form,
  Jumbotron,
  Modal,
  ModalBody,
  ModalFooter,
  Spinner,
} from 'reactstrap';
import { CREATE_CHANNEL_MESSAGES } from '../../mutation/mutation';
import MultiImageUpload from '../sav-lovebox/components/MultiImageUpload';

const ChannelMessageCreator = (props) => {
  const { channelId } = props;

  const [modal, toggleModal] = useState(false);
  const [modalSuccess, toggleModalSuccess] = useState(false);
  const [modalError, toggleModalError] = useState(false);

  const [canSubmit, setCanSubmit] = useState(false);

  const [createChannelMessages] = useMutation(CREATE_CHANNEL_MESSAGES);

  const onCreateChannelMessage = async () => {
    toggleModal(true);
    const channelMessages = [];
    for (let index = 0; index < frImages.length; index += 1) {
      channelMessages.push({
        pictureFr: frImages[index],
        pictureEn: enImages[index],
      });
    }
    createChannelMessages({ variables: { channelMessages, channelId } })
      .then(() => { toggleModalSuccess(true); })
      .catch((err) => { toggleModalError(err.message); });
  };

  const closeModalError = () => {
    toggleModal(false);
    toggleModalError(false);
  };

  const [frImages, setFrImages] = useState([]);
  const [enImages, setEnImages] = useState([]);

  useEffect(() => {
    setCanSubmit(frImages.length > 0 && enImages.length > 0 && frImages.length === enImages.length);
  }, [frImages, enImages]);

  return (
    <Jumbotron className="templates">
      <Container>
        <Form>
          <h5>French images:</h5>
          <MultiImageUpload setImages={setFrImages} />
          <h5>English images:</h5>
          <MultiImageUpload setImages={setEnImages} />
          {frImages.length > 0 && enImages.length > 0 && frImages.length !== enImages.length && (
            <p>You need to upload the same number of French and English images to submit</p>
          )}
          <Button color="success" disabled={!canSubmit} onClick={onCreateChannelMessage}>Add to channel</Button>
        </Form>
      </Container>
      <Modal isOpen={modal} toggle={toggleModal} className="modalTemplate">
        {modalSuccess && (
          <ModalBody>
            Channel Messages Uploaded
            <ModalFooter>
              {/* eslint-disable-next-line no-undef */}
              <Button color="success" onClick={() => window.location.reload()}>Ok</Button>
            </ModalFooter>
          </ModalBody>
        )}
        {modalError && (
          <ModalBody>
            Error creating template :
            {modalError}
            <ModalFooter>
              <Button color="danger" onClick={closeModalError}>Ok</Button>
            </ModalFooter>
          </ModalBody>
        )}
        {!modalSuccess && !modalError && (
          <Spinner color="primary" />
        )}
      </Modal>
    </Jumbotron>
  );
};

export default ChannelMessageCreator;



// WEBPACK FOOTER //
// ./src/components/channels/ChannelMessageCreator.js